import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

/**
 * 承运商
 */
// export const getCarrier = params => axios({
//   url: `${commonPath}carrier/list`,
//   method: 'post',
//   data: params
// })

/**
 * 分拣人
 */
export const getPickingMemberAll = params => axios({
  url: `${commonPath}picking/member/all`,
  method: 'post',
  data: params
})

/**
 * 包装类型
 */
// export const getPackingType = () => axios({
//   url: `${commonPath}packing_type/all`,
//   method: 'get'
// })

/**
 * 运单类型
 */
// export const getWaybillType = () => axios({
//   url: `${commonPath}waybill/type/list`,
//   method: 'get'
// })

/**
 * 运单状态
 */
// export const getWaybillStatus = () => axios({
//   url: `${commonPath}waybill/status/list`,
//   method: 'get'
// })

/**
 * 货运方式
 */
// export const getShippingMethod = params => axios({
//   url: `${commonPath}shipping/method/list`,
//   method: 'post',
//   data: params
// })

/**
 * 关单类型
 */
// export const getTariffType = () => axios({
//   url: `${commonPath}tariff/bill_nature/list`,
//   method: 'get'
// })

/**
 * 报关方式
 */
// export const setTariffMethod = () => axios({
//   url: `${commonPath}tariff/filing/type`,
//   method: 'get'
// })
